import { Typography } from "@material-ui/core";
export function TabHeader({ children, ...rest }) {
  return (
    <div
      style={{
        padding: "8px 16px 0 0",
        height: "32px",
        marginLeft: "-16px",
      }}
      {...rest}
    >
      <Typography variant="h3">{children}</Typography>
    </div>
  );
}
